import {
  CButton,
  CButtonGroup,
  CCol,
  CFormGroup,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem, updateItem, ItemRequestStatus } from "../../api/generics";
import Errors, { getFieldErrors } from "../../models/errors";
import { SUCCESS } from "../../utils/constants/tags";
import { FieldErrors } from "../form/FieldErrors";
import { errorAlert } from "../utils/messages";
import { emptyValueOnUndefined } from "../../utils/fields";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import DocumentCategory, {
  newDocumentCategory,
} from "../../models/document-category";

interface DocumentCategoryFormProps {
  initialDocumentCategory?: DocumentCategory;
  initialErrors?: Errors;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DocumentCategoryForm: React.FC<DocumentCategoryFormProps> = ({
  initialDocumentCategory,
  initialErrors,
  onCancel,
  onSuccess,
}) => {
  const company = useSelector((state: RootState) => state.company.data.company);
  const [editingDocumentCategory, setEditingDocumentCategory] =
    useState<DocumentCategory>(
      initialDocumentCategory ? initialDocumentCategory : newDocumentCategory()
    );

  const [errors, setErrors] = useState<Errors>(
    initialErrors ? initialErrors : {}
  );
  const [submitting, setSubmitting] = useState(false);

  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditingDocumentCategory({
      ...editingDocumentCategory,
      name: e.target.value,
    });
  };

  const onSave = async () => {
    setSubmitting(true);
    let toSendDocumentCategory = {
      ...editingDocumentCategory,
      companyId: company.id,
    };
    let requestPromise: Promise<ItemRequestStatus<DocumentCategory>>;
    if (editingDocumentCategory.id === undefined) {
      requestPromise = createItem<DocumentCategory>(
        "/document_categories/create/",
        toSendDocumentCategory
      );
    } else {
      requestPromise = updateItem<DocumentCategory>(
        `/document_categories/${toSendDocumentCategory.id}/`,
        toSendDocumentCategory
      );
    }

    const documentCategoriestatus = await requestPromise;

    if (documentCategoriestatus.status !== SUCCESS) {
      if (documentCategoriestatus.errors !== undefined) {
        setErrors(documentCategoriestatus.errors);
      }

      let message = "Ha ocurrido un error!!";
      if (documentCategoriestatus.detail !== undefined) {
        message = documentCategoriestatus.detail;
      }
      errorAlert(message);
    } else {
      setErrors({});
      clearForm();
      onSuccess();
    }
    setSubmitting(false);
  };

  const onClose = () => {
    clearForm();
    onCancel();
  };

  const clearForm = () => {
    setEditingDocumentCategory(newDocumentCategory());
  };

  useEffect(() => {
    setEditingDocumentCategory(
      initialDocumentCategory ? initialDocumentCategory : newDocumentCategory()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialDocumentCategory]);

  useEffect(() => {
    setErrors(initialErrors ? initialErrors : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialErrors]);

  return (
    <>
      <fieldset disabled={submitting}>
        <CFormGroup>
          <CRow>
            <CCol md={2}>
              <CLabel>Nombre:</CLabel>
            </CCol>
            <CCol>
              <CInput
                type="text"
                value={emptyValueOnUndefined(editingDocumentCategory.name)}
                onChange={onNameChange}
                placeholder="Nombre"
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("name", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
        <CFormGroup className="float-right">
          <CButtonGroup>
            <CButton type="button" color="secondary" onClick={onClose}>
              Atras
            </CButton>
            <CButton type="submit" color="primary" onClick={onSave}>
              {submitting ? (
                <Spinner
                  animation="grow"
                  style={{
                    height: "17px",
                    width: "17px",
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginRight: "10px",
                  }}
                />
              ) : (
                <></>
              )}
              {submitting ? "Guardando..." : "Guardar"}
            </CButton>
          </CButtonGroup>
        </CFormGroup>
      </fieldset>
    </>
  );
};

export default DocumentCategoryForm;
